import Service from "../../AuthService";
const Customer = {
    getCustomer(page) {
        return Service.get("/customer?page="+page);
    },
    getAllCustomer() {
        return Service.get("/customer_all");
    },
        setAllCustomerDropdown() {
        return Service.get("/customer_all_dropdown");
    },
    showCustomer(id) {
        return Service.get("/customer/" + id);
    },
    showSubCustomer(id) {
        return Service.get("/get_customer-other/"+ id);
    },
    updateCustomer(id, data) {
        return Service.put("/customer/" + id, data);
    },
    createCustomer(data) {
        return Service.post("/customer", data);
    },
    deleteCustomer(id) {
        return Service.delete("/customer/" + id);
    },
    searchCustomer(page,customer, sale) {
        return Service.post(
            "/search-customer?page="+page+"&customer="+customer+"&sale="+sale
        );
    },
    generateCustomerID(data){
        return Service.post("/get_customer_id", data);
    },
    getCustomerTransportForm(){
        return Service.get("/customer_transport_form");
    },
    getTransportTypeWrap(){
        return Service.get("/transport_type_wrap");
    },

    //customer other
    getCustomerOtherList(page){
        return Service.get("/customer-other?page="+page);
    },
    getCustomerOtherById(customer_id){
        return Service.get("/customer-other/"+customer_id);
    },
    setFixedRate(data){
        return Service.get(`/customer_set_fixed_rate?fix_rate=${data.fix_rate}&customer_id=${data.customer_id}&customer_type=${data.customer_type}`);
    },
    createCustomerOther(data){
        return Service.post("/customer-other",data);
    },
    updateCustomerOther(id,data){
        return Service.put("/customer-other/"+id,data);
    },
    saveTransportFeeCustomer(data){
        return Service.post("/save_transport_foam_customer",data);
    },
    saveTransportFeeCustomerOther(data){
        return Service.post("/save_transport_foam_customer_other",data);
    },

    //setting fix for customer other
    getSettingFix(){
        return Service.get("/customer-fix-price");
    },
    createSettingFix(data){
        return Service.post("/customer-fix-price",data);
    },
    updateSettingFix(id,data){
        return Service.put("/customer-fix-price/"+id,data);
    },
    uploadFileCustomer(data){
        return Service.post("/upload_file_customer",data);
    },
    uploadTransportCustomer(data){
        return Service.post(`/update_transport_customer/${data.id}`,data);
    },
    uploadTransportOtherCustomer(data){
        return Service.post(`/update_transport_customer_other/${data.id}`,data);
    },
    getCustomerTransportEdit(page,data){
      return Service.get(`/transport_foam_customer?page=${page}&customer_id=${data.customer_id}&sale_id=${data.sale_id}&area_id=${data.area_id}&province_id=${data.province_id}&districts_id=${data.districts_id}`,)
    },
    getCustomeSubrTransportEdit(page,data){
      return Service.get(`/transport_foam_customer_sub?page=${page}&customer_id=${data.customer_id}&sale_id=${data.sale_id}&area_id=${data.area_id}&province_id=${data.province_id}&districts_id=${data.districts_id}`,)
    },
    //รายงานลูกค้าย่อย
    exportTran(data){
        return Service.get(`/update/log_customer_other_transport?seller=${data.seller}&customer=${data.customer}`);
    },
    exportTrip(data){
        return Service.get(`/update/log_customer_other_foam_price?seller=${data.seller}&customer=${data.customer}`);
    },
    updateCustomerTransportPrice(data){
        return Service.post(`/update/update_customer_transport_price`,data);
    },
        updateCustomerOtherTransportPrice(data){
        return Service.post(`/update/update_customer_other_transport_price`,data);
    }
}


;
export default Customer;
